module.exports = new __parcel__URL__("wl_icon_large.d9ce9657.png").toString();